import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/swiper-bundle.css';
import PodcastCard from '../components/PodcastCard';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import SectionHeader from '../components/SectionHeader';
import Icon from '../../common/components/Icon';
import { useTranslations } from '../../localization/useTranslations';

const LifePodcast = () => {
  const podcastCards = window.lifePodcastCards;
  const translations = useTranslations();

  const updateButtonVisibility = (swiper: any) => {
    const { isBeginning, isEnd } = swiper;
    const prevButton = document.querySelector('.podcasts__button--prev');
    const nextButton = document.querySelector('.podcasts__button--next');

    if (isEnd) {
      nextButton?.classList.add('carousel-button--hidden');
    } else {
      nextButton?.classList.remove('carousel-button--hidden');
    }

    if (isBeginning) {
      prevButton?.classList.add('carousel-button--hidden');
    } else {
      prevButton?.classList.remove('carousel-button--hidden');
    }
  };

  return (
    <div className="react-block__life-podcast">
      <div className="container">
        <SectionHeader
          title={translations?.lifeContent?.lifePodcast || 'Life! Podcast'}
          linkLabel={translations?.lifeContent?.moreForbesPodcast || 'All Podcasts'}
          isExternal
        />
        <div className="react-block__carousel react-block__carousel--podcast">
          <div className="carousel-button podcasts__button--prev button button--primary button--large">
            <Icon name="arrow-left" size="small" />
          </div>
          <div className="carousel-button podcasts__button--next button button--primary button--large">
            <Icon name="arrow-right" size="small" />
          </div>
          <Swiper
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            className="react-block__swiper"
            spaceBetween={30}
            slidesPerView={1}
            navigation={{
              nextEl: '.podcasts__button--next',
              prevEl: '.podcasts__button--prev',
            }}
            onSwiper={(swiper: any) => {
              updateButtonVisibility(swiper);
            }}
            onSlideChange={(swiper: any) => {
              updateButtonVisibility(swiper);
            }}
            enabled={false}
            breakpoints={{
              991: {
                slidesPerView: 2.5,
                enabled: true,
              },
            }}
          >
            {podcastCards.map((card, index) => (
              <SwiperSlide key={index}>
                <PodcastCard
                  title={card.title}
                  tag={card.tag}
                  buttonLabel={card.buttonLabel}
                  imageUrl={card.imageUrl}
                  duration={card.duration}
                  tagUrl={card.tagUrl}
                  url={card.url}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default LifePodcast;
